import * as React from 'react';
import { LoadingScreen } from '../LoadingScreen';
import { Card } from '../Card';
import { EOffersClickAction } from '../../../../types/tracking';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var LayoutsCards = function LayoutsCards(_ref) {
  var layouts = _ref.layouts,
    isLoading = _ref.isLoading,
    columnsNumber = _ref.columnsNumber,
    trackClick = _ref.trackClick;
  var columnsStyle = React.useMemo(function () {
    return {
      gridTemplateColumns: "repeat(".concat(columnsNumber, ", minmax(auto, 263px))")
    };
  }, [columnsNumber]);
  var onCardLinkClick = React.useCallback(function () {
    trackClick(EOffersClickAction.fromDeveloper);
  }, [trackClick]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }
  return /*#__PURE__*/_jsx("div", {
    className: style['cards-list'],
    style: columnsStyle,
    children: layouts.map(function (layout, i) {
      return /*#__PURE__*/_jsx(Card, {
        layout: layout,
        onClick: onCardLinkClick
      }, i);
    })
  });
};